import type { TechnographicSelection } from './types';

type Condition = TechnographicSelection['mode'];

/**
 * The one wording for a technology's condition (NPJB-787 AC1, AC6). Every surface — the chip,
 * its tooltip, the Activate hand-off banner — reads it from here, so no two places drift. The
 * stored values stay `runs` / `notRuns`; only what a reader sees is "Uses" / "Doesn't use".
 */
export const CONDITION_LABEL: Record<Condition, string> = {
  runs: 'Uses',
  notRuns: "Doesn't use",
};

/** "Uses Splunk" / "Doesn't use CRM". */
export const technologyPhrase = (mode: Condition, label: string): string =>
  `${CONDITION_LABEL[mode]} ${label}`;

/**
 * NPJB-787 AC3. "Doesn't use" can only match accounts we have swept for technology; an account
 * with no technology data is unknown, so it is left out rather than counted as a non-user.
 */
export const DOESNT_USE_NOTE = "Doesn't use leaves out accounts we have no technology data for.";
